import {
  Button as LibButton,
  ButtonProps as LibButtonProps,
  ButtonKind as LibButtonKind,
  ButtonSize as LibButtonSize,
} from "@flaminem/ui-components";

import { useT } from "src/internationalization";

export type ButtonProps = Omit<LibButtonProps, "loadingText"> & {
  loadingText?: string;
};

export type ButtonKind = LibButtonKind;
export type ButtonSize = LibButtonSize;

export const Button = ({ size = "lg", ...props }: ButtonProps) => {
  const t = useT();
  return <LibButton {...props} size={size} loadingText={props.loadingText ?? t("app.loading")} />;
};
